// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardMessageBanner_container__xdRi3"};